import React, { useRef, useState } from 'react'
import Input from '../../UI/Input';
import { insertRequest, updateRequest } from '../../../api/webServices';
import './Request.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logoFuneraria from '../../../imgs/logoFuneraria.png';
import ReactToPrint from 'react-to-print';
import { replaceQuotes } from '../../../utils/various';

const inputsDef = [
    'cabezalLugar',
    'cabezalFecha',
    'cabezalPlan',
    'cabezalInmediato',
    'cabezalFecha',
    'cabezalAsesor',
    'cabezalTitular',
    'cabezalContrato',
    'cabezalTipoPlan',
    'cabezalCantidad',
    'cabezalSaldo',
    'solicitanteNombre',
    'solicitanteDomicilio',
    'solicitanteLocalidad',
    'solicitanteParentesco',
    'solicitanteTel1',
    'solicitanteTel2',
    'fallecidoLugar',
    'fallecidoNombre',
    'fallecidoLugarDefuncion',
    'fallecidoLugar',
    'fallecidoCausa',
    'fallecidoFechaNac',
    'fallecidoFechaDef',
    'fallecidoEdad',
    'fallecidoEstadoCivil',
    'ceremoniaFamilia',
    'ceremoniaDia',
    'ceremoniaHora',
    'ceremoniaTemplo',
    'ceremoniaPanteon',
    'ceremoniaNovenarios',
    'ceremoniaRadio',
    'ceremoniaImpresa',
    'ceremoniaPagina',
    'ceremoniaFotografia',
    'servicioAtaud',
    'servicioEmbalsamada',
    'servicioEspecial',
    'servicioEncapsulado',
    'servicioNocheAdicional',
    'servicioCremacion',
    'servicioSala',
]

let emptyInputs = {};

inputsDef.forEach(input => {
    emptyInputs[input] = '';
});

const Request = () => {

    const { requestMode, actualRequest } = useSelector(state => state.requests);
    const { sessionData } = useSelector(state => state.session);
    if (requestMode === 'new') emptyInputs.cabezalAsesor = sessionData?.name;
    const [inputs, setInputs] = useState(requestMode === 'update' || requestMode === 'view' ? JSON.parse(actualRequest?.data) : emptyInputs);
    const navigate = useNavigate();
    const requestRef = useRef();

    const createInput = (label, name, width, disabled) => {
        let newWidth = width || 100;
        return (
            <Input name={name} onChange={change} disabled={requestMode === 'view' || disabled} value={inputs[name]} width={newWidth} className="h-5 inputForm text-[11px]" parentClassName="inline-block" labelTop={label} />
        )
    }
    const change = (e) => {
        let id = e.target.id;
        setInputs({ ...inputs, [id]: e.target.value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let parsedData = replaceQuotes(inputs);
        if (requestMode === 'update') {
            updateRequest({ id: actualRequest.id, data: JSON.stringify(parsedData) }).then(res => {
                navigate('/requests');
            }).catch(err => {
                console.log(err);
            })
        }
        if (requestMode === 'new') {
            insertRequest({ data: JSON.stringify(parsedData) }).then(res => {
                navigate('/requests');
            }).catch(err => {
                console.log(err);
            })
        }
        if (requestMode === 'view') {
            navigate('/requests');
        }
    }

    const getTitle = () => {
        switch (requestMode) {
            case 'update':
                return 'Editar solicitud';
            case 'view':
                return 'Solicitud';
            default:
                return 'Crear solicitud';
        }
    }

    const getDescriptionAccept = () => {
        switch (requestMode) {
            case 'update':
                return 'Aceptar';
            case 'view':
                return 'Volver';
            default:
                return 'Aceptar';
        }
    }

    return (
        <div className="w-full h-screen">
            <h1 className="pb-5 text-2xl text-center requestFormTitle">{getTitle()}</h1>
            <div ref={requestRef} className="relative max-w-[1000px] mx-auto requestFormBody px-24 bg-white p-9 pt-4 rounded-xl text-md font-sans">
                <img className="absolute top-12 left-8" src={logoFuneraria} width={'150px'} alt='logo' />
                <div className="flex flex-row items-center justify-center w-full">
                    <div className="p-5 text-[10px] text-center">
                        <h2 className="mb-5 text-xl font-bold text-center text-black">SANTUARIO CASA FUNERAL</h2>
                        OFICINAS: FEDERICO DEL TORO # 312, CAPILLAS: LEANDRO VALLE # 25, CD. GUZMAN, JALISCO.
                        <br></br>
                        TELEFONOS: (341) 413 0510 Y (341) 413 8644
                        <br></br>
                        CORREO: santuariocasafuneral@hotmail.com
                        <br></br>
                        FACEBOOK: Santuario Casa Funeral.
                    </div>
                </div>
                <div>{createInput('LUGAR DE VELACION', 'cabezalLugar', 350)}</div>
                <br></br>
                <div>{createInput('FECHA', 'cabezalFecha', 350)}</div>
                <br></br>
                <div>
                    {createInput('SERVICIO CON PLAN', 'cabezalPlan', 60)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('SERVICIO INMEDIATO', 'cabezalInmediato', 60)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('ASESOR', 'cabezalAsesor', 200, true)}
                </div>
                <br></br>
                <div>{createInput('NOMBRE DEL TITULAR', 'cabezalTitular', 400)}</div>
                <br></br>
                <div>
                    {createInput('N. CONTRATO', 'cabezalContrato', 200)}                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('TIPO DE PLAN', 'cabezalTipoPlan', 200)}                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('CANTIDAD ABONADA', 'cabezalCantidad', 160)}  <p>&nbsp;&nbsp;&nbsp;&nbsp;</p><p>&nbsp;</p>
                    {createInput('SALDO $', 'cabezalSaldo', 225)}<p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                </div>
                <br></br>
                <div className="bg-blue-800">
                    <h2 className="text-center text-white">DATOS DEL SOLICITANTE</h2>
                </div>
                <div>{createInput('NOMBRE DE QUIEN AUTORIZA', 'solicitanteNombre', 400)}</div>
                <br></br>
                <div>{createInput('DOMICILIO', 'solicitanteDomicilio', 400)}</div>
                <br></br>
                <div>
                    {createInput('LOCALIDAD', 'solicitanteLocalidad', 200)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('MUNICIPIO', 'solicitanteLocalidad', 200)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    <br></br>
                    {createInput('PARENTESCO', 'solicitanteParentesco', 400)}
                </div>
                <br></br>
                <div>
                    {createInput('TELEFONO 1', 'solicitanteTel1', 200)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('TELEFONO 2', 'solicitanteTel2', 200)}
                </div>
                <br></br>
                <div className="bg-blue-800">
                    <h2 className="text-center text-white">DATOS DEL FALLECIDO</h2>
                </div>
                <div>{createInput('LUGAR DE VELACIÓN', 'fallecidoLugar', 450)}</div>
                <br></br>
                <div>{createInput('NOMBRE DEL FALLECIDO', 'fallecidoNombre', 450)}</div>
                <br></br>
                <div>{createInput('LUGAR DE DEFUNCIÓN', 'fallecidoLugarDefuncion', 450)}</div>
                <br></br>
                <div>{createInput('CAUSAS DE LA DEFUNCIÓN', 'fallecidoCausa', 450)}</div>
                <br></br>
                <div>{createInput('FECHA DE NACIMIENTO', 'fallecidoFechaNac', 450)}</div>
                <br></br>
                <div>{createInput('FECHA DE DEFUNCIÓN', 'fallecidoFechaDef', 450)}</div>
                <br></br>
                <div>{createInput('EDAD', 'fallecidoEdad', 200)}</div>
                <br></br>
                <div>{createInput('ESTADO CIVIL', 'fallecidoEstadoCivil', 200)}</div>
                <br></br>
                <div className="bg-blue-800">
                    <h2 className="text-center text-white">DATOS CEREMONIALES</h2>
                </div>
                <div>{createInput('FAMILIA QUE LE PARTICIPA', 'ceremoniaFamilia', 200)}</div>
                <br></br>
                <div>{createInput('DIA DE MISA', 'ceremoniaDia', 200)}</div>
                <br></br>
                <div>{createInput('HORA', 'ceremoniaHora', 200)}</div>
                <br></br>
                <div>{createInput('TEMPLO', 'ceremoniaTemplo', 200)}</div>
                <br></br>
                <div>{createInput('PANTEON', 'ceremoniaPanteon', 200)}</div>
                <br></br>
                <div>{createInput('NOVENARIOS', 'ceremoniaNovenarios', 200)}</div>
                <br></br>
                <div>
                    {createInput('SPOTS RADIO', 'ceremoniaRadio', 50)}
                    {createInput('ESQUELAS IMPRESAS', 'ceremoniaImpresa', 50)}
                    {createInput('PUBLICACION PAGINA', 'ceremoniaPagina', 50)}
                    {createInput('FOTOGRAFIA', 'ceremoniaOtro', 50)}
                </div>
                <br></br>
                <div className="bg-blue-800">
                    <h2 className="text-center text-white">SERVICIOS</h2>
                </div>
                <div>{createInput('Ataúd Modelo', 'servicioAtaud', 200)}</div>
                <br></br>
                <div>
                    {createInput('Embalsamada', 'servicioEmbalsamada', 100)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('Especial (Semefo)', 'servicioEspecial', 100)}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                    {createInput('Encapsulado', 'servicioEncapsulado', 100)}
                </div>
                <br></br>
                <div>
                    {createInput('Noche Adicional', 'servicioNocheAdicional', 100)}
                    <p>&nbsp;&nbsp;&nbsp;</p>
                    {createInput('Cremación', 'servicioCremacion', 100)}
                    <p>&nbsp;&nbsp;&nbsp;</p>
                    {createInput('Salas Recinto Américas', 'servicioSala', 100)}
                </div>
            </div>
            <div className="flex flex-row items-center justify-center w-full gap-20 pb-9">
                <button className="h-8 text-white duration-150 bg-blue-500 rounded-md cursor-pointer w-36 hover:bg-blue-900" onClick={handleSubmit}>{getDescriptionAccept()}</button>
                <ReactToPrint
                    trigger={() => <button className="h-8 text-white duration-150 bg-blue-500 rounded-md cursor-pointer w-36 hover:bg-blue-900">Generar PDF</button>}
                    content={() => requestRef.current}
                />
            </div>
        </div>
    )
}

export default Request